import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {  fetchProductsStart } from './../redux/Products/products.actions';
import {  addProduct } from './../redux/Cart/cart.actions';
import { Form } from 'react-bootstrap'
import {Link} from 'react-router-dom'
import DashAuthWrapper from './../components/DashAuthWrapper'
import Checkout from './../components/Checkout';

import Button from './../components/forms/Button'
import { selectCartTotal, selectCartItemsCount, selectCartItems } from './/../redux/Cart/cart.selectors';

const mapState = (state) => ({
	totalNumCartItems: selectCartItemsCount(state),
	total: selectCartTotal(state),
	cartItems: selectCartItems(state),
	products: state.productsData.products
});

const mapState2 = ({ user }) => ({
	currentUser: user.currentUser,
})

const Services = props => {
	const { products, total, totalNumCartItems, cartItems } = useSelector(mapState);
	const { currentUser } = useSelector(mapState2);
  	const dispatch = useDispatch();

	const { data } = products;

	useEffect(() => {
		window.scrollTo(0, 0)
	}, [])

	useEffect(() => {
		dispatch(
			fetchProductsStart()
		);
	// eslint-disable-next-line
	}, []);

	
	//sort orders by date
	// function compare(a, b) {
	// 	const bandA = a.orderCreatedDate;
	// 	const bandB = b.orderCreatedDate;
	
	// 	let comparison = 0;
	// 	if (bandA < bandB) {
	// 	comparison = 1;
	// 	} else if (bandA > bandB) {
	// 	comparison = -1;
	// 	}
	// 	return comparison;
	// }
	// if(orderHistory){
	// 	orderHistory.sort(compare)
	// }

	// const currentOrderAddonsArray = []

	//checks most recent orders for addons
	// if(orderHistory){
	// 	if(orderHistory[0]){
	// 		for(let j = 0; j < orderHistory[0].orderItems.length; j++){
	// 			if(orderHistory[0].orderItems[j].productCategory === "Add-ons"){
	// 				currentOrderAddonsArray.push(orderHistory[0].orderItems[j]);
	// 			}
	// 		}
	// 	}
	// }

	const plansArray = [];
	if(Array.isArray(data)){
		for(let i = 0; i < data.length; i++){
			if(data[i].productCategory === "plans"){
			plansArray.push(data[i]);
			}
		}
	}
	
	const addonsArray = [];
	if(Array.isArray(data)){
	  for(let i = 0; i < data.length; i++){
		if(data[i].productCategory === "Add-ons"){
		  addonsArray.push(data[i]);
		}
	}}

	

	const checkAddOnsArray = [];
	if(Array.isArray(cartItems)){
	  for(let i = 0; i < cartItems.length; i++){
		if(cartItems[i].productCategory === "Add-ons"){
			checkAddOnsArray.push(cartItems[i]);
		}
	}}

	

	//create and filter array to show only services not selected
	let filteredServiceArry = addonsArray.filter(item1 => 
		!checkAddOnsArray.some(item2 => (item2.productName === item1.productName)))


	


	//add default plan to cart since only one option and is required
	// useEffect(() => {
	// 	if(!plansArray[0]) {
	// 		return;
	// 	}
	// 	dispatch(
	// 		addProduct(plansArray[0])
	// 	  );
	// 	  // eslint-disable-next-line
	// }, []);

	// useEffect(() => {
	// 	if(!currentOrderAddonsArray[0]) {
	// 		return;
	// 	}

	// 	for(let i = 0; i < currentOrderAddonsArray.length; i++){
	// 		dispatch(
	// 			addProduct(currentOrderAddonsArray[i])
	// 		);
	// 	}
	// 	// eslint-disable-next-line
	// }, []);


	// console.log('Add-ons:', currentOrderAddonsArray)
	// console.log('cart:',cartItems)

	const handleAddToCart = (product) => {
		if (!product) return;
		dispatch(
		  addProduct(product)
		);
		// history.push('/cart');
		
	}
		
	const configAddToCartBtn = {
		type: 'button'
	  };

	
	return (
		<DashAuthWrapper >


		{/*------------- NEW CUSTOMER-------------- */}
		{!currentUser.subscribed ?(
			<div>
				<h1>What are you looking for?</h1>
				<Form className="mx-auto mt-5">
					<div className="row custPlan d-flex justify-content-center">
						{/* <div className="col-lg-6 col-sm-12 text-left">
							<Form.Group controlId="plan">
							<Form.Label>Which Plan?</Form.Label>
							<div className="addOnGroup p-3">
								{(Array.isArray(plansArray) && plansArray.length > 0) && plansArray.map((product, index) => {
									const {
										productName,
										documentID,
										productPrice
									} = product;
									if (!documentID || !productName ||
										typeof productPrice === 'undefined') return null;
									return (
										<div className="row label">
										<label className="m-1 label" for={documentID}>{productName}- ${productPrice}</label>
										<div className="text-right col">
											<button className="add-btn mt-1" {...configAddToCartBtn} onClick={() => handleAddToCart(product)}>
												Add
											</button>
										</div>
										</div>
									)
								})}
							</div>
							</Form.Group>
						</div> */}
					
						<div className="col-lg-12 col-sm-12 text-left">
							<Form.Group controlId="addOn">
								<Form.Label>Add ons?</Form.Label>
								<div className="addOnGroup p-3">
									{filteredServiceArry.map((product, index) => {
										const {
											productName,
											documentID,
											productPrice,
											productDesc
										} = product;
										if (!documentID || !productName ||
											typeof productPrice === 'undefined') return null;
										return (
											<div className="row label planDetail">
												<label className="m-1 col" for={documentID}>{productName}

														{productDesc &&(
															<span className="planTooltip">{productDesc}</span>
															)		 
														}
												
												</label>
												<div className="text-right col">
													${productPrice}
												</div>
												<div className="text-right col">
													<button className="add-btn mt-1" {...configAddToCartBtn} onClick={() => handleAddToCart(product)}>
														Add
													</button>
												</div>
											</div>
										)
									})}
								</div>
							</Form.Group>
						</div>
					</div>

					
					<div className="mt-3">

						
						<p style={{fontWeight:"600"}}>Total: ${(Math.round((total) * 100) / 100).toFixed(2)}</p>
					</div>
					<div className="mt-5">
						<Link to="/cart">
							<Button >

								
								YOUR CART ({totalNumCartItems})
							</Button>
						</Link>
						<Link to="/dashboard">
							<Button className="btn cancel mx-3">
								CANCEL
							</Button>
						</Link>
					</div>	
					
				</Form>
			</div>
		):(

			// ------------- EXISTING CUSTOMER--------------
			<div>
				<h1>What are you looking for?</h1>

				<Form className="mx-auto mt-5">
					<div className="row custPlan d-flex justify-content-center">
						
					
						<div className="col-lg-12 col-sm-12 text-left">
							<Form.Group controlId="addOn">
								<Form.Label>Add ons?</Form.Label>
								<div className="addOnGroup p-3">
									{filteredServiceArry.map((product, index) => {
										const {
											productName,
											documentID,
											productPrice,
											productDesc
										} = product;
										
										// for(let i = 0; i < currentOrderAddonsArray.length; i++){
										// 	if(currentOrderAddonsArray[i].productName === productName){
										// 		return (
										// 			<div className="row label planDetail" key={index}>
										// 				<label className="m-1 col" for={documentID}>{productName}
		
										// 						{productDesc &&(
										// 							<span className="planTooltip">{productDesc}</span>
										// 							)		 
										// 						}
														
										// 				</label>
										// 				<div className="text-right col">
										// 					${productPrice}
										// 				</div>
										// 				<div className="text-right col">
										// 					<button className="remove-btn mt-1" {...configAddToCartBtn} onClick={() => handleAddToCart(product)}>
										// 						Remove
										// 					</button>
										// 				</div>
		
										// 			</div>
										// 		)
										// 	}else{
												return (
													<div className="row label planDetail" key={index}>
														<label className="m-1 col" htmlFor={documentID}>{productName}
															{productDesc &&(
																<span className="planTooltip">{productDesc}</span>
																)		 
															}
														</label>
														<div className="text-right col">
															${productPrice}
														</div>
														<div className="text-right col">
															<button className="add-btn mt-1" {...configAddToCartBtn} onClick={() => handleAddToCart(product)}>
																Add
															</button>
															
														</div>
													</div>
												)
										// 	}
										// }
										
									})}
								</div>
							</Form.Group>
						</div>
					</div>

{/* 					
					<div className="mt-3">

						
						<p style={{fontWeight:"600"}}>Total: ${(Math.round((total) * 100) / 100).toFixed(2)}</p>
					</div>
					<div className="mt-5">
						<Link to="/cart">
							<Button >

								
								YOUR CART ({totalNumCartItems})
							</Button>
						</Link>
						<Link to="/dashboard">
							<Button className="btn cancel mx-3">
								CANCEL
							</Button>
						</Link>
					</div>	 */}
					
				</Form>
			</div>
		)}

		<Checkout/>
		
		</DashAuthWrapper>
	)
}

export default Services;